import { useAppSelector } from '~/hooks/useAppSelector';

export const useRecoveryPasswordController = () => {
  const { currentStep } = useAppSelector(
    ({ forgotPassword }) => forgotPassword,
  );
  return { currentStep };
};
